import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.flat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.array.unscopables.flat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { chatApi } from '@/api/chatApi';
import { serchSelect } from "@/mixins/index";
import { listNo } from "@/api/advRelation";
import { createThreadd, createMessage, getThreadList, getThreadMessages, deleteThread } from "@/api/index/index";
import MarkdownIt from 'markdown-it';
import echartsContainer from './echartsContainer.vue';
var md = new MarkdownIt({
  html: true,
  // 允许 HTML 标签
  linkify: true,
  // 将 URL 地址转为链接
  typographer: true,
  breaks: true // 转化段落里的换行

});
export default {
  mixins: [serchSelect],
  components: {
    echartsContainer: echartsContainer
  },
  data: function data() {
    return {
      loading: false,
      dialogShow: false,
      searchData: {},
      showSelectData: false,
      activeThreadId: '',
      inputContent: '',
      chatHistory: [],
      currentMessages: [],
      // abortController: null,
      chatCache: {},
      abortControllers: {},
      isNewMessage: false,
      keyword: '',
      checkAll: false,
      selectedIds: [],
      productAllList: [],
      // checkProductAll:false,
      // checkProductInvert: false, 
      rules: {
        special_product_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }]
      }
    };
  },
  watch: {
    // 监听当前配置对象的变化
    activeChatConfig: {
      immediate: true,
      // 页面初始化时也执行一次
      handler: function handler(newConfig) {
        console.log("newConfig==", newConfig);

        if (newConfig && newConfig.ad_channel) {
          // 只要切换了会话，且该会话有渠道信息，就去查对应的位置列表
          console.log("newConfig.ad_channel===", newConfig.ad_channel);
          this.advChannelchangeMore(newConfig.ad_channel.split(','));
        } else {
          this.advLocation = [];
        }
      }
    }
  },
  computed: {
    isIndeterminate: function isIndeterminate() {
      var checkedCount = this.selectedIds.length;
      return checkedCount > 0 && checkedCount < this.chatHistory.length;
    },
    activeChatConfig: function activeChatConfig() {
      var _this = this;

      if (!this.activeThreadId || this.chatHistory.length === 0) return null;
      return this.chatHistory.find(function (item) {
        return item.thread_id === _this.activeThreadId;
      });
    },
    // 添加计算属性
    fullProductStr: function fullProductStr() {
      var _this2 = this;

      // 1. 获取选中的产品列表对象
      var selectedProducts = this.productsList.filter(function (item) {
        return _this2.searchData.special_product_id.includes(item.id);
      }); // 2. 获取渠道和位置 (处理多选数组)

      var channels = this.searchData.ad_channel || [];
      var placements = this.searchData.ad_placement || [];
      var combinations = [];
      selectedProducts.forEach(function (prod) {
        var base = "".concat(prod.game_mark, ":").concat(prod.platform_mark, ":").concat(prod.channel_mark, ":").concat(prod.pkg_mark);

        if (channels.length === 0 && placements.length === 0) {
          combinations.push(base);
        } else if (channels.length > 0 && placements.length === 0) {
          channels.forEach(function (ch) {
            combinations.push("".concat(base, ":").concat(ch));
          });
        } else {
          channels.forEach(function (ch) {
            placements.forEach(function (pl) {
              combinations.push("".concat(base, ":").concat(ch, ":").concat(pl));
            });
          });
        }
      });
      return combinations.join(',');
    }
  },
  methods: {
    productChange: function productChange(val) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ids;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // this.checkProductAll = val.length == this.productsList.length && this.productsList.length > 0;
                ids = val.toString();
                _context.next = 3;
                return _this3.upCurrency();

              case 3:
                if (!_this3.isPayChannel) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return _this3.upPayChannel();

              case 6:
                _this3.getAdvPlarform(ids ? {
                  special_product_id: ids
                } : {
                  game_id: _this3.rawData.game_id
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleSelectAll: function toggleSelectAll(isChecked) {
      if (isChecked) {
        this.searchData.special_product_id = this.productsList.map(function (item) {
          return item.id;
        });
      } else {
        // 取消全选：清空数组
        this.searchData.special_product_id = [];
      } // 可选：触发产品选择变化时的回调


      this.productChange(this.searchData.special_product_id);
    },
    toggleInvertSelect: function toggleInvertSelect() {
      // 获取所有产品的 ID
      var allProductIds = this.productsList.map(function (item) {
        return item.id;
      }); // 获取当前已选中的 ID

      var currentSelected = this.searchData.special_product_id; // 反选逻辑：选中所有未选中的，取消所有已选中的

      this.searchData.special_product_id = allProductIds.filter(function (id) {
        return !currentSelected.includes(id);
      }); // 触发变化回调

      this.productChange(this.searchData.special_product_id); // 可选：反选后取消全选状态（因为不再是全选状态了）
      // this.checkProductAll = false;
    },
    getNamesArray: function getNamesArray(list, idsStr, type) {
      if (!idsStr || !list || list.length === 0) return []; // 1. 将字符串按逗号拆分为数组，并去除空格

      var idArray = String(idsStr).split(',').map(function (s) {
        return s.trim();
      }); // 2. 遍历 ID 数组，从数据源中找对应的名称

      if (type == 'product') {
        return idArray.map(function (id) {
          var target = list.find(function (item) {
            return item.id == id;
          });
          return target ? target.name : id;
        });
      }

      if (type == 'ad_channel') {
        return idArray.map(function (id) {
          var target = list.find(function (item) {
            return item.adv_platform_mark == id;
          });
          return target ? target.adv_platform_name : id;
        });
      }

      if (type == 'ad_placement') {
        return idArray.map(function (id) {
          var target = list.find(function (item) {
            return item.adv_place_mark == id;
          });
          return target ? target.adv_place_name : id;
        });
      }
    },
    // 辅助方法：将名称数组转为逗号字符串用于直接显示
    formatNames: function formatNames(list, idsStr, type) {
      var names = this.getNamesArray(list, idsStr, type);
      return names.length > 0 ? names.join('、') : '';
    },
    renderMarkdown: function renderMarkdown(text) {
      if (!text) return '';
      var content = text;

      try {
        if (typeof text === 'string' && (text.startsWith('"') || text.startsWith('{'))) {
          content = this.safeJsonParse(text);
        }
      } catch (e) {
        content = text;
      }

      return md.render(content);
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.selectedIds = val ? this.chatHistory.map(function (i) {
        return i.thread_id;
      }) : [];
    },
    // 单个选中切换
    toggleSelect: function toggleSelect(id) {
      var idx = this.selectedIds.indexOf(id);

      if (idx > -1) {
        this.selectedIds.splice(idx, 1);
      } else {
        this.selectedIds.push(id);
      } // 自动更新全选框状态


      this.checkAll = this.selectedIds.length == this.chatHistory.length;
    },
    searchHistoryData: function searchHistoryData() {
      this.chatCache = {};
      this.activeThreadId = '';
      this.currentMessages = [];
      this.getHistoryData();
    },
    open: function open() {
      this.dialogShow = true;
      this.isNewMessage = false;
      this.inputContent = '';
      this.getHistoryData();
      this.getProductList();
      this.showSelectData = false;
      this.currentMessages = [];
      this.searchData = {
        special_product_id: [],
        ad_channel: [],
        ad_placement: []
      };
      this.advchannels = this.$store.state.d2admin.serchSelect.advchannels;
      this.productsList = this.$store.state.d2admin.serchSelect.productsList;
      console.log("this.productsList==", this.productsList);
      setTimeout(function () {
        var dialogs = document.querySelectorAll('.dialogs');
        dialogs.forEach(function (dialog) {
          dialog.style.paddingTop = '0';
          dialog.style.paddingBottom = '0';
        });
      }, 100);
    },
    getProductList: function getProductList() {
      var _this4 = this;

      listNo().then(function (resq) {
        if (resq.status == 200) {
          _this4.productAllList = resq.data;
          console.log("this.productAllList==", _this4.productAllList);
        }
      });
    },
    getHistoryData: function getHistoryData() {
      var _this5 = this;

      getThreadList({
        keyword: this.keyword
      }).then(function (res) {
        if (res.status == 200) {
          _this5.chatHistory = res.data;

          if (_this5.chatHistory.length) {
            var firstThreadId = _this5.chatHistory[0].thread_id;
            _this5.activeThreadId = firstThreadId;

            _this5.handleSelect(firstThreadId);
          } else {
            _this5.showSelectData = true;
          }
        }
      });
    },
    dataSelect: function dataSelect() {
      if (this.searchData.special_product_id.length === 0) {
        this.$message.warning("请至少选择一个产品！");
        return;
      }

      if (this.searchData.ad_channel && this.searchData.ad_channel.length > 0) {
        if (!this.searchData.ad_placement || this.searchData.ad_placement.length === 0) {
          this.$message.warning("选择了广告渠道，请至少选择一个广告位置！");
          return;
        }
      }

      this.isNewMessage = true;
      this.showSelectData = false;
    },
    handleButtonClick: function handleButtonClick() {
      var isCurrentAiLoading = this.currentMessages.length > 0 && this.currentMessages[this.currentMessages.length - 1].loading;

      if (isCurrentAiLoading) {
        this.stopGeneration();
      } else {
        this.sendMessage();
      }
    },
    stopGeneration: function stopGeneration() {
      var id = this.activeThreadId;

      if (id && this.abortControllers[id]) {
        this.abortControllers[id].abort();
        delete this.abortControllers[id];
      }

      this.loading = false; // 按钮图标变回“发送”

      if (this.currentMessages.length > 0) {
        var lastMsg = this.currentMessages[this.currentMessages.length - 1];

        if (lastMsg.role === 'ai') {
          lastMsg.loading = false; // 隐藏消息中的三个点动画
        }
      } // 同步缓存


      if (this.activeThreadId) {
        this.$set(this.chatCache, this.activeThreadId, _toConsumableArray(this.currentMessages));
      }
    },
    startNewChat: function startNewChat() {
      if (this.activeThreadId) {
        this.chatCache[this.activeThreadId] = _toConsumableArray(this.currentMessages);
      }

      this.currentMessages = [];
      this.showSelectData = true;
      this.activeThreadId = ''; // this.checkProductAll = false;
      // this.checkProductInvert = false

      this.searchData = {
        special_product_id: [],
        ad_channel: [],
        ad_placement: []
      };
    },
    handleSelect: function handleSelect(id) {
      var _this6 = this;

      console.log("this.activeThreadId===", this.activeThreadId);
      console.log("this.chatCache", this.chatCache);
      this.isNewMessage = false;

      if (this.activeThreadId) {
        this.$set(this.chatCache, this.activeThreadId, _toConsumableArray(this.currentMessages || []));
      } // this.stopGeneration();


      console.log("id===", id);
      this.activeThreadId = id;

      if (this.chatCache[id] && this.chatCache[id].length > 0) {
        this.currentMessages = this.chatCache[id];
        console.log("this.currentMessages==", this.currentMessages);
        var lastMsg = this.currentMessages[this.currentMessages.length - 1]; // 如果最后一条是 AI 且在加载中，图标变“停止”，否则变“发送”
        // const isGenerating = !!(lastMsg && lastMsg.role === 'ai' && lastMsg.loading);
        // const hasActiveRequest = !!this.abortControllers[id];
        // // 同步全局 loading 状态（控制右下角图标）
        // this.loading = isGenerating || hasActiveRequest;

        var hasActiveRequest = !!this.abortControllers[id];
        var isMsgLoading = !!(lastMsg && lastMsg.role === 'ai' && lastMsg.loading); // 如果请求已经结束（没有控制器了），但消息还卡在 loading 状态，强制修正它

        if (!hasActiveRequest && isMsgLoading) {
          this.$set(lastMsg, 'loading', false);
        } // 全局 loading 状态由是否有正在进行的请求决定


        this.loading = hasActiveRequest;
        this.scrollToBottom();
      } else {
        this.currentMessages = [];
        this.loading = false;
        getThreadMessages({
          thread_id: id
        }).then(function (res) {
          if (res.status == 200) {
            var history = res.data.map(function (item) {
              var userMsg = {
                role: 'user',
                content: item.user_message,
                send_datetime: item.send_datetime
              };
              var aiMsg = {
                role: 'ai',
                reasoning: '',
                done: '',
                chartOption: null,
                firstAppeared: item.firstAppeared || 'reasoning',
                loading: false,
                isReasoningCollapsed: true
              };

              if (item.reasoning) {
                aiMsg.reasoning = _this6.safeJsonParse(item.reasoning);
              }

              if (item.message) {
                aiMsg.message = _this6.safeJsonParse(item.message);
              }

              if (item.done) {
                aiMsg.done = _this6.safeJsonParse(item.done);
              }

              if (item.chartOption) {
                aiMsg.chartOption = _this6.safeJsonParse(item.chartOption);
              }

              if (item.error) {
                aiMsg.error = _this6.safeJsonParse(item.error);
              }

              if (item.done_datetime) {
                aiMsg.done_datetime = item.done_datetime;
              }

              return [userMsg, aiMsg];
            }).flat();

            _this6.$set(_this6.chatCache, id, history);

            if (_this6.activeThreadId === id) {
              _this6.currentMessages = _this6.chatCache[id];

              _this6.scrollToBottom();
            } // this.currentMessages = history;
            // this.chatCache[id] = [...this.currentMessages];
            // // 滚动到底部
            // this.scrollToBottom();

          }
        });
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    sendMessage: function sendMessage() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var lastMsg, res, newChatEntry, params, userQuestion, currentSendingThreadId, aiMessageIndex, userMsg, aiMsg, collectedData, newController, lastEvent;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this7.loading) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this7.inputContent.trim()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                lastMsg = _this7.currentMessages[_this7.currentMessages.length - 1];

                if (_this7.activeThreadId && _this7.abortControllers[_this7.activeThreadId]) {
                  if (lastMsg && lastMsg.role === 'ai' && lastMsg.loading) {
                    console.log("[\u4F1A\u8BDD ".concat(_this7.activeThreadId, "] \u6B63\u5728\u751F\u6210\u4E2D\uFF0C\u6267\u884C\u8986\u76D6\u7EC8\u6B62"));

                    _this7.abortControllers[_this7.activeThreadId].abort();

                    lastMsg.loading = false;

                    _this7.$set(lastMsg, 'error', '已终止并重新发送');
                  } // 清理掉这个已经没用的控制器引用


                  delete _this7.abortControllers[_this7.activeThreadId];
                }

                _this7.scrollToBottom();

                if (_this7.activeThreadId) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 10;
                return chatApi.createThread(_this7.fullProductStr);

              case 10:
                res = _context2.sent;

                if (!res) {
                  _context2.next = 19;
                  break;
                }

                _this7.activeThreadId = res.thread_id; // --- 关键代码：将新对话插入左侧历史 ---

                newChatEntry = {
                  thread_id: res.thread_id,
                  title: _this7.inputContent,
                  created_at: _this7.formatDate(new Date().toISOString()),
                  // 使用当前时间
                  game_id: _this7.searchData.special_product_id.join(','),
                  ad_channel: _this7.searchData.ad_channel ? _this7.searchData.ad_channel.join(',') : '',
                  ad_placement: _this7.searchData.ad_placement ? _this7.searchData.ad_placement.join(',') : ''
                };

                _this7.chatHistory.unshift(newChatEntry);

                params = {
                  thread_id: res.thread_id,
                  special_product_id: _this7.searchData.special_product_id.toString(),
                  //this.rawData.game_id,
                  ad_channel: _this7.searchData.ad_channel,
                  ad_placement: _this7.searchData.ad_placement
                };
                _context2.next = 18;
                return createThreadd(params);

              case 18:
                _this7.$set(_this7.chatCache, _this7.activeThreadId, []);

              case 19:
                userQuestion = _this7.inputContent;
                currentSendingThreadId = _this7.activeThreadId; // this.currentMessages.push({ role: 'user', content: userQuestion,send_datetime: this.formatDate(new Date().toISOString()) });

                _this7.inputContent = '';
                aiMessageIndex = _this7.currentMessages.length; // this.currentMessages.push({
                //   role: 'ai',
                //   reasoning: '',
                //   message: '',
                //   firstAppeared: null,
                //   done: '',
                //   chartOption: null,
                //   error: '',
                //   loading: true,
                //   isReasoningCollapsed: false,
                //   done_datetime: '',
                // });

                userMsg = {
                  role: 'user',
                  content: userQuestion,
                  send_datetime: _this7.formatDate(new Date())
                };
                aiMsg = {
                  role: 'ai',
                  reasoning: '',
                  message: '',
                  firstAppeared: null,
                  done: '',
                  chartOption: null,
                  error: '',
                  loading: true,
                  isReasoningCollapsed: false,
                  done_datetime: ''
                };

                if (!_this7.chatCache[currentSendingThreadId]) {
                  _this7.$set(_this7.chatCache, currentSendingThreadId, []);
                } // 将消息推入该 threadId 对应的缓存数组


                _this7.chatCache[currentSendingThreadId].push(userMsg, aiMsg);

                if (_this7.activeThreadId == currentSendingThreadId) {
                  _this7.currentMessages = _this7.chatCache[currentSendingThreadId];
                  _this7.loading = true;

                  _this7.scrollToBottom();
                } // const aiMsg = this.currentMessages[aiMessageIndex];


                _this7.loading = true; // 开始 Loading

                collectedData = {
                  thread_id: _this7.activeThreadId,
                  user_message: userQuestion,
                  reasoning: '',
                  message: '',
                  firstAppeared: null,
                  done: '',
                  chartOption: null,
                  error: '',
                  send_datetime: _this7.formatDate(new Date().toISOString()),
                  done_datetime: ''
                }; // 2. 创建新的控制器

                newController = new AbortController();

                _this7.$set(_this7.abortControllers, _this7.activeThreadId, newController);

                lastEvent = '';
                _context2.prev = 33;
                _context2.next = 36;
                return chatApi.sendMessage(currentSendingThreadId, userQuestion, function (rawData) {
                  console.log("data====", data);
                  var data;

                  try {
                    // 如果 rawData 已经是对象则直接用，如果是字符串则解析
                    data = typeof rawData === 'string' ? _this7.safeJsonParse(rawData) : rawData;
                  } catch (e) {
                    console.error("JSON 解析失败，原始数据内容：", rawData); // 尝试简单的正则修复：如果是因为包含未转义的换行符

                    try {
                      var fixedData = rawData.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
                      data = JSON.parse(fixedData);
                    } catch (e2) {
                      return; // 实在解析不了就跳过这一个数据包
                    }
                  }

                  var isEventChanged = lastEvent && lastEvent !== data.event;
                  var separator = isEventChanged ? '\n\n' : '';

                  if (data.event == 'reasoning') {
                    var textToAdd = separator + (data.reasoning || '');
                    aiMsg.reasoning += textToAdd;
                    collectedData.reasoning += textToAdd;
                    aiMsg.firstAppeared = 'reasoning';
                    collectedData.firstAppeared = 'reasoning';
                    collectedData.done_datetime = _this7.formatDate(new Date().toISOString());
                    lastEvent = 'reasoning';

                    _this7.scrollToBottom();
                  }

                  if (data.event == 'message') {
                    var _textToAdd = separator + (data.content || '');

                    aiMsg.message += _textToAdd;
                    collectedData.message += _textToAdd;
                    aiMsg.firstAppeared = 'message';
                    collectedData.firstAppeared = 'message';
                    collectedData.done_datetime = _this7.formatDate(new Date().toISOString());
                    lastEvent = 'message';

                    _this7.scrollToBottom();
                  }

                  if (data.event == 'done') {
                    _this7.$set(aiMsg, 'loading', false); // this.loading = false;


                    aiMsg.done = data.content;

                    if (data.artifact && data.artifact.echarts_option) {
                      aiMsg.chartOption = data.artifact.echarts_option;
                      collectedData.chartOption = data.artifact.echarts_option;
                    }

                    aiMsg.loading = false;
                    aiMsg.isReasoningCollapsed = true;
                    collectedData.done = data.content;
                    collectedData.done_datetime = _this7.formatDate(new Date().toISOString());

                    _this7.$set(aiMsg, 'done_datetime', _this7.formatDate(new Date().toISOString()));

                    lastEvent = '';

                    _this7.scrollToBottom();

                    if (_this7.activeThreadId == currentSendingThreadId) {
                      _this7.loading = false;
                    }

                    delete _this7.abortControllers[_this7.activeThreadId];

                    _this7.saveMessageToBackend(collectedData);
                  } // 3. 处理 Error 结果


                  if (data.event == 'error') {
                    _this7.$set(aiMsg, 'loading', false); //this.loading = false;


                    aiMsg.error = data.content;
                    aiMsg.loading = false;
                    aiMsg.isReasoningCollapsed = true;
                    collectedData.error = data.content;
                    collectedData.done_datetime = _this7.formatDate(new Date().toISOString());

                    _this7.$set(aiMsg, 'done_datetime', _this7.formatDate(new Date().toISOString()));

                    lastEvent = '';

                    _this7.scrollToBottom();

                    if (_this7.activeThreadId == currentSendingThreadId) {
                      _this7.loading = false;
                    }

                    delete _this7.abortControllers[_this7.activeThreadId];

                    _this7.saveMessageToBackend(collectedData);
                  } // if (this.activeThreadId) {
                  //   this.chatCache[this.activeThreadId] = [...this.currentMessages];
                  // }
                  // this.$set(this.chatCache, currentSendingThreadId, [...this.currentMessages]);

                }, newController.signal);

              case 36:
                _context2.next = 42;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t0 = _context2["catch"](33);

                if (aiMsg) {
                  aiMsg.loading = false;

                  _this7.$set(aiMsg, 'done_datetime', _this7.formatDate(new Date().toISOString()));
                } // 关键点：判断是否是手动中断引发的错误


                if (_context2.t0.name == 'AbortError') {
                  console.log('请求已被用户手动中断');

                  if (aiMsg) {
                    _this7.$set(aiMsg, 'error', '当前会话已终止');
                  } // 这里不需要向后端保存消息，因为会话没完成

                } else {
                  // 处理真正的网络错误或其他异常
                  console.error('发送消息出错:', _context2.t0);

                  _this7.$message.error("发送失败，请稍后重试");

                  _this7.loading = false;
                }

              case 42:
                _context2.prev = 42;
                // 无论成功还是被中断，最终都要清理状态
                _this7.abortController = null;
                delete _this7.abortControllers[currentSendingThreadId];

                if (_this7.activeThreadId === currentSendingThreadId) {
                  _this7.loading = false;
                }

                return _context2.finish(42);

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[33, 38, 42, 47]]);
      }))();
    },
    safeJsonParse: function safeJsonParse(str) {
      if (!str) return null;
      if (typeof str !== 'string') return str;

      try {
        // 核心：利用正则将 JSON 字符串中未包裹双引号的 NaN 统一替换为标准的 null
        var cleanedStr = str.replace(/:\s*NaN\b/g, ': null').replace(/\[\s*NaN\s*\]/g, '[null]').replace(/,\s*NaN\s*/g, ', null ').replace(/\bNaN\b/g, 'null'); // 兜底替换

        return JSON.parse(cleanedStr);
      } catch (e) {
        console.error("JSON清洗后依旧解析失败，保留原字符串。错误信息：", e, "原始数据：", str);
        return str; // 如果实在解析不了，返回原样，防止前端彻底卡死
      }
    },
    saveMessageToBackend: function saveMessageToBackend(params) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params.reasoning = params.reasoning ? JSON.stringify(params.reasoning) : '';
                params.message = params.message ? JSON.stringify(params.message) : '';
                params.done = params.done ? JSON.stringify(params.done) : '';
                params.chartOption = params.chartOption ? JSON.stringify(params.chartOption) : '';
                params.error = params.error ? JSON.stringify(params.error) : '';
                _context3.next = 7;
                return createMessage(params);

              case 7:
                console.log("this.isNewMessage==", _this8.isNewMessage);

                if (_this8.isNewMessage) {
                  _this8.getHistoryData();
                }

                console.log("消息已成功存入数据库");

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    deleteChat: function deleteChat() {
      var _this9 = this;

      var idsToDelete = this.selectedIds;
      this.$confirm("此操作将删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        console.log("idsToDelete", idsToDelete);
        deleteThread({
          thread_id: idsToDelete
        }).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!(res.status == 200)) {
                      _context4.next = 10;
                      break;
                    }

                    _this9.$message.success("删除成功!"); // if (this.activeThreadId == id) {
                    //   this.currentMessages = []; 
                    //   this.$delete(this.chatCache, id); // 删除对应的缓存
                    // }
                    // idsToDelete.forEach(id => {
                    //   if (this.chatCache[id]) {
                    //     this.$delete(this.chatCache, id);
                    //   }
                    // });
                    // if (idsToDelete.includes(this.activeThreadId)) {
                    //   this.activeThreadId = '';
                    //   this.currentMessages = [];
                    // }


                    _this9.chatCache = {};
                    _this9.activeThreadId = '';
                    _this9.currentMessages = []; // this.currentMessages = [];

                    _this9.selectedIds = [];
                    _this9.checkAll = false;
                    _context4.next = 9;
                    return _this9.getHistoryData();

                  case 9:
                    console.log("this.activeThreadId", _this9.activeThreadId);

                  case 10:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    },
    scrollToBottom: function scrollToBottom() {
      var _this10 = this;

      this.$nextTick(function () {
        var container = _this10.$el.querySelector('.message-list');

        setTimeout(function () {
          var container = _this10.$el.querySelector('.message-list');

          if (container) {
            container.scrollTo({
              top: container.scrollHeight,
              behavior: 'smooth' // 平滑滚动

            });
          }
        }, 50);
      });
    }
  }
};